module.exports = __webpack_public_path__ + "img/coupon-popup-item-use.cb9952e7.png";